import React from 'react';
import LoginForm from '../components/LoginForm';
import './Login.css';

function Login() {
  return <LoginForm />;
}

export default Login;
